import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'
import getters from './getters'
import { getUserId, getOrganization } from '@/utils/auth'
import { getQueryObject } from '@/utils/index'
// import { getEnvironment } from '@/api/login'


Vue.use(Vuex)

export function getMetric() {
    let groundStationConfig = localStorage.getItem("groundStationConfig")
    let metric = 1;
    if (groundStationConfig) {
        groundStationConfig = JSON.parse(groundStationConfig);
        const groundStation = groundStationConfig.groundStation || {};
        metric = (groundStation.scale || 1) * 1
    }
    return metric;
}

export function getUnit() {
    const metric = getMetric();
    let unit = {
        meter: 'm',
        speed: 'm/s'
    }
    if (metric === 2) {
        unit = {
            meter: 'ft',
            speed: 'mph'
        }
    }
    return unit;
}

// 获取AK，请求头加入AK
const { AK } = getQueryObject()

const state = {
    // 用来区分在线和离线地面站(true：在线，false：离线)
    // online:false,
    online: true,
    privatization: false,//是否是私有化保护署，只有私有化部署才会显示产品售后页面
    loginOnline: true,
    earth3d: false,
    // 用户id
    userId: getUserId(),
    organization: getOrganization(),
    AK,
    uavid: null,
    cpuId: null,
    // 全局电子围栏发生变化的时间戳（全局 WS code=4 推送时更新），页面 watch 这个值触发重新拉取
    globalFenceUpdatedAt: 0,
    // 无人机类型
    uavType: null,
    // uavType: 'VTL',
    // 无人机的拥有权
    isOwn: false,
    // 接管控制还是释放控制
    takeOverType: 2,
    // 无人机轨迹
    trackState: true,
    // 无人机升级信息
    upgradeInfo: undefined,
    // 是否处于测量中的状态
    inSurvey: false,
    // 公制还是英制(1：公制，2：英制)
    metricAndBritishSystem: getMetric(),
    unit: getUnit(),
    // 校准反馈
    CF: null,
    // 挂载设备通用状态
    devGeneralStatus: false,
    // 是否在飞行中
    isFlight: false,
    // 是否有新消息
    newsDot: false,
    newsNumber: 0,
    // 车牌识别
    LPR: false,
    // 单机，多机模式
    controlMode: true,
    // 是否处于推流状态
    isPlugFlow: true,
    // 分辨率
    streamType: [],
    streamList: [],
    aliVideoUrl: '',// 当前播放的视频源
    // devType
    GB: 51, // 云台
    SPK: 143, // 喊话器
    GW: 253, // 网关
    TC: 4, // TC
    LDR: 67, // 生命探测雷达
    FC: 1, // 飞控
    // ftp下载进度
    ftpDownloadProgress: {

    },
    // 摇杆状态
    remoteControlStatus: null,
    uavAttitude: {
        pitch: 0,
        roll: 0,
        yaw: 0
    },
    // 地图相关配置
    mapConfig: {
        mapboxUrl: 'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}{r}?access_token={accessToken}',
        accessToken: 'pk.eyJ1IjoidHRhdmlhdGlvbiIsImEiOiJjbDJ1MnIzdnYwYTk2M2NvNnk4b3plbDdpIn0.XN8zg2IuGiAfbbI8KLZqqw',
        idNormal: 'ttaviation/cl2u93fba001214qz42xp9by2', // 电子地图样式id
        idSatellite: 'ttaviation/cl2u2zovr000g15nus7q4eq23', // 卫星地图样式id
        normalMapUrl: 'https://uav.ttaviation.com:17083/tms/m/{z}/{x}/{y}', // 电子地图
        // satelliteMapUrl: 'https://uav.ttaviation.com:17083/tms/s/{z}/{x}/{y}', // 卫星地图
        // 天机图的卫星地图
        satelliteMapUrl: 'http://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=5c6af87ceeb4d4603c8251cf381fb5e0', // 卫星地图
        /* normalMapUrl: '/tms/m/{z}/{x}/{y}', // 电子地图
        satelliteMapUrl: '/tms/s/{z}/{x}/{y}', // 卫星地图 */
        /* normalMapUrl: 'https://gac-geo.googlecnapps.cn/maps/vt?lyrs=m&x={x}&y={y}&z={z}', // 电子地图
        satelliteMapUrl: 'https://gac-geo.googlecnapps.cn/maps/vt?lyrs=m&x={x}&y={y}&z={z}', // 卫星地图 */
        // normalMapUrl: '/styles/v1/{id}/tiles/{z}/{x}/{y}{r}?access_token={accessToken}', // 电子地图
        // satelliteMapUrl: '/styles/v1/{id}/tiles/{z}/{x}/{y}{r}?access_token={accessToken}', // 卫星地图 
        offlineUrlNormal: '/tms/m/{z}/{x}/{y}', // 离线版电子地图样式链接
        offlineUrlSatellite: '/tms/s/{z}/{x}/{y}', // 离线版卫星地图样式链接
    },
    // 分组数据
    groupList: [],
    targetPointData: [],
    // 输入通道映射-遥控器通道值
    aisleData: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    // 禁飞区数据
    noFlyZone: [],
    // 限飞区数据
    restrictedFlyZone: [],
    // 解禁区数据
    unrestrictedAreas: [],
    // 电子围栏
    electronicFence: undefined,
    returnHome: {},
    // 解算目标点
    targetSolutionShow: false,
    targetSolution: {
        lng: 0,
        lat: 0,
        alt: 0,
        dist: 0
    },
    waypointAltCharts: false,
    allDeviceList: { rtks: [], uavs: [] },
    //飞行检查
    flightInspection: {
        flightCheckStatus: {
            sensor: false,
            structure: false,
            communication: false,
            configure: false,
            load: false,
            airspace: false
        },
        flightInspectionData: {}
    },

    // 抛放器挂点状态
    throwerHangingPointStatus: '[]',
    throwerHangingPointColor: '[]',
    // 探照灯状态
    searchlightStatus: '{}',
    // 缓降器状态
    descenderStatus: '{}',
    onlineUavs: '[]',
    copyFormationData: {
        value: [],
        directionAngle: 0,
        gridDistance: 1,
    },

    diagonal: 0,
}

const mutations = {
    setState(state, payload) {
        state[payload.key] = payload.value
    },
    // 设置用户id
    setUserId(state, payload) {
        state.userId = payload;
    },
    // 设置无人机id
    setUavid(state, payload) {
        state.uavid = payload;
    },
    setCpuId(state, payload) {
        state.cpuId = payload;
    },
    // 设置无人机类型
    setUavType(state, payload) {
        state.uavType = payload;
    },
    // 设置为无人机的拥有权
    setOwn(state, payload) {
        // 0:未拥有,1:拥有
        if (payload == 1) {
            state.isOwn = true;
        } else {
            state.isOwn = false;
        }
    },
    // 设置控制类型
    setTakeOverType(state, payload) {
        state.takeOverType = payload;
    },
    setTrackState(state, type) {
        state.trackState = type;
    },
    // 设置测量状态
    setMeasure(state, payload) {
        state.inSurvey = payload;
    },
    // 设置公英制
    setUnit(state, payload) {
        state.metricAndBritishSystem = payload;
        if (payload === 1) {
            state.unit = {
                meter: 'm',
                speed: 'm/s'
            };
        } else if (payload === 2) {
            state.unit = {
                meter: 'ft',
                speed: 'mph'
            };
        }
    },
    // 设置校准反馈
    setCF(state, payload) {
        state.CF = payload;
    },

    // 设置挂载设备通用状态
    setDevGeneralStatus(state, payload) {
        state.devGeneralStatus = payload;
    },
    // 设置飞行状态
    setFlight(state, payload) {
        state.isFlight = payload;
    },
    // 设置消息状态
    setNewsDot(state, payload) {
        state.newsDot = payload;
    },
    setNewsNumber(state, payload) {
        state.newsNumber = payload < 0 ? 0 : payload;
    },
    // 进入车牌识别模式
    setLPR(state, payload) {
        state.LPR = payload;
    },
    // 设置单机多机模式
    setControlMode(state, payload) {
        state.controlMode = payload;
    },
    // 设置推流状态
    setIsPlugFlow(state, payload) {
        state.isPlugFlow = payload;
    },
    // 分辨率
    setStreamType(state, payload) {
        state.streamType = payload;
    },
    setStreamList(state, payload) {
        state.streamList = payload;
    },
    setFtpDownloadProgress(state, payload) {
        state.ftpDownloadProgress = payload;
    },
    setRemoteControlStatus(state, payload) {
        state.remoteControlStatus = payload;
    },
    setOnline(state, payload) {
        state.online = payload;
    },
    setGroupList(state, payload) {
        state.groupList = payload;
    },
    setTargetPointData(state, payload) {
        state.targetPointData = payload;
    },
    setAisleData(state, payload) {
        state.aisleData = payload;
    },
    setReturnHome(state, payload) {
        state.returnHome = payload;
    },
    setFlightInspection(state, payload) {
        state.flightInspection = payload;
    }
}

const actions = {
    getEnvironment({ commit }) {
        return new Promise((resolve, reject) => {
            /* getEnvironment().then(response => {
                const { data } = response
                console.log(response);
                resolve()
            }).catch(error => {
                reject(error)
            }) */

            Axios
                .get("/config.json")
                .then((response) => {
                    const { status, data } = response;
                    if (status === 200) {
                        const { online, loginOnline } = data;
                        if (online) {
                            // 在线
                            commit("setState", {
                                key: "online",
                                value: true,
                            });
                        } else {
                            // 离线
                            commit("setState", {
                                key: "online",
                                value: false,
                            });
                        }

                        commit("setState", {
                            key: "loginOnline",
                            value: loginOnline,
                        });
                    }

                    resolve()
                })
                .catch((error) => {
                    reject(error)
                });
        })
    },
}

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    // set './app.js' => 'app'
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
    const value = modulesFiles(modulePath)
    modules[moduleName] = value.default
    return modules
}, {})

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
    modules
})
